<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary">
      <figure>
        <v-chart :options="chart"
                 ref="quantidadeChart"
                 theme="secondary"
                 autoresize/>
      </figure>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import chartMixin from '@/mixins/chart-mixin';
import { buildCategoryEnumChart, toEchartData } from '@/utils/chart-utils';
import IndicadoresService from './dashboard-service';

const COLOR_MAP = {
  ABERTA: '#FFB300',
  EM_ANDAMENTO: '#FFB300',
  FINALIZADA: '#43A047',
  CANCELADA: '#F4511E',
};

export default {
  props: {
    stringFilter: String,
  },
  data() {
    return {
      indicadores: null,
      chart: null,
    };
  },
  mixins: [chartMixin],
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getIndicadores();
    },
  },
  methods: {
    showLoading() {
      this.$refs.quantidadeChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.quantidadeChart) {
        return;
      }
      this.$refs.quantidadeChart.hideLoading();
    },
    buildChart() {
      const chartData = buildCategoryEnumChart(this.indicadores, SituacaoCotacao.keys);
      return {
        title: {
          text: 'Quantidade de cotações por situação',
        },
        tooltip: {
          trigger: 'axis',
          formatter: this.tooltipTextFormatterAxis,
        },
        dataset: {
          source: [
            ['Quantidade'],
            ...toEchartData(chartData, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          interval: 1,
          maxInterval: 1,
          splitNumber: 1,
          axisLabel: {
            rotate: -45,
            formatter: this.axisFormatterTruncate(5),
          },
        },
        grid: {
          left: '15%',
        },
        series: [
          {
            realtimeSort: true,
            seriesLayoutBy: 'column',
            type: 'bar',
            barMaxWidth: 16,
            itemStyle: {
              color(param) {
                const { data } = param;
                return COLOR_MAP[data[2]] || '#0277BD';
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
    },
    getIndicadores() {
      this.showLoading();
      IndicadoresService.getIndicadores(
        {
          filter: this.stringFilter,
        },
      )
        .then((response) => {
          this.indicadores = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
  mounted() {
    this.getIndicadores();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
  /*max-width: 400px;*/
}
</style>
